import { verifyValidContractId } from '../serverRequests'

export const verifyIfIsValidContractId = async (id, token) => {
  return verifyValidContractId({ fileId: id }, token)
    .then(response => {
      if(response.data.isValidId) {
        return true
      }
      return false
    })
}

export const verifyIfIsValidPeriod = (period) => {
  period = parseInt(period)
  if(period >= 1 && period <= 12) {
    return true
  }
  return false
}

export const verifyIfIsValidYear = (year) => {
  const regex = /^\d{4}$/
  const match = regex.test(year)
  if(match) {
    return true
  }
  return false
}